import React, { useState, useEffect, useCallback } from "react";
import { Trans, useTranslation } from "react-i18next";
import { Form, Input, Result, Alert, Modal } from "antd";
import Spin from "Components/Spinner";
import { RightOutlined, LoadingOutlined, ReloadOutlined } from "@ant-design/icons";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import SelectPaymentMethodModal from "../../../Shared/SelectPaymentMethodModal";
import { order_post } from "api/orders";
import { payment_mbway_post } from "api/payments";
import WaitingAnimation from "./WaitingAnimation";
import Timeout from "./Timeout";
import Declined from "./Declined";
import Failed from "./Failed";
import UserBlocked from "Components/Shared/UserBlocked";
import { IsNullUndefinedEmpty } from "utils/helper";
import CustomButton from "Components/CustomButton";
import moment from "moment-timezone";
import { utmParams } from "utils/helper";
const { utm_source, utm_medium, utm_campaign, utm_term, utm_content } = utmParams();
const env = process.env?.ENVIRONMENT?.toLowerCase() || "development";

// const renderTime = ({ remainingTime }) => {
//   try {
//     if (remainingTime === 0) {
//       return <div className="timer">Oops</div>;
//     }

//     if (remainingTime >= 60) {
//       // Arredonda para múltiplos de 10 para reduzir updates visuais
//       const rounded = Math.floor(remainingTime / 10) * 10;
//       const minutes = Math.floor(rounded / 60);
//       const seconds = rounded % 60;

//       return (
//         <div className="timer">
//           <div className="text">Restam</div>
//           <div className="value">
//             {minutes}m{seconds > 0 ? ` e ${seconds}s` : ""}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <div className="timer">
//         <div className="text">Restam</div>
//         <div className="value">{remainingTime} segundos</div>
//       </div>
//     );
//   } catch (error) {
//     return <></>;
//   }
// };

const parseInternationalPhoneNumber = (phone) => {
  try {
    // console.log("parseInternationalPhoneNumber: ", phone);
    // Fix phone number (remove +351, 00351, 351)
    if (phone.startsWith("+351")) {
      phone = phone.substring(4);
    }
    if (phone.startsWith("351")) {
      phone = phone.substring(3);
    }

    // Check if phone number starts with 91, 92, 93, 96
    if (phone.startsWith("91") || phone.startsWith("92") || phone.startsWith("93") || phone.startsWith("96")) {
      return phone;
    }

    return "";
  } catch (error) {
    return "";
  }
};

/***********************************************************************************************
 ***********************************************************************************************
 ***********************************************************************************************
 * ##: APP
 ***********************************************************************************************
 ***********************************************************************************************
 **********************************************************************************************/
const MBWay = ({ productData, data, actionHandler, step, customStyle, checkResponse, setCheckResponse, stopCheckHandler, setShowChangeMethod }) => {
  const [formMBWay] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [countdownIsPlaying, setCountdownIsPlaying] = useState(false);
  const [showPhoneInput, setShowPhoneInput] = useState(true);
  const [selectPaymentMethod, setSelectPaymentMethod] = useState({ visible: false });
  const [mbwayPhoneNumber, setMbwayPhoneNumber] = useState("");
  const [validPhoneNumber, setValidPhoneNumber] = useState(false);
  const [paymentDataResponse, setPaymentDataResponse] = useState({});
  const [waitForPayment, setWaitForPayment] = useState(false);
  const [paymentTimeout, setPaymentTimeout] = useState(false);
  const [requestStatus, setRequestStatus] = useState(null);

  const [errorFetching, setErrorFetching] = useState(false);
  const [paid, setPaid] = useState(false);

  useEffect(() => {
    if (setShowChangeMethod) setShowChangeMethod(showPhoneInput);
    return () => {
      if (setShowChangeMethod) setShowChangeMethod(false);
    };
  }, [showPhoneInput]);

  useEffect(() => {
    const status = data?.status?.action;
    setPaid(status === "paid");

    if (mbwayPhoneNumber === "") {
      if (IsNullUndefinedEmpty(data?.identification?.phone) === false) {
        setMbwayPhoneNumber(parseInternationalPhoneNumber(data.identification.phone));
        formMBWay.setFieldsValue({ phone: parseInternationalPhoneNumber(data.identification.phone) });
        formMBWay.validateFields(["phone"]);
      }
    }
  }, [data]);

  useEffect(() => {
    if (["Declined", "Timeout", "Error", "Error-E0506"].includes(checkResponse)) {
      cancelCheckPayment(checkResponse);
      actionHandler("mbway_refused", {
        data: {},
      });
    }
  }, [checkResponse]);

  // useEffect(() => {
  //   if (paymentTimeout === true || errorFetching === true) {
  //     actionHandler("update_status", {
  //       action: "checkout",
  //       data: {},
  //     });
  //   }
  // }, [paymentTimeout, errorFetching]);

  const createOrder = (payload) => {
    return new Promise((resolve) => {
      try {
        order_post(payload)
          .then((res) => resolve({ status: true, data: res }))
          .catch((err) => resolve({ status: false, data: err }));
      } catch (error) {
        resolve({ status: false, data: error });
      }
    });
  };

  const cleanMBWAYPhoneNumber = (mbwayPhone) => {
    try {
      // return phone
      //   .replace(/ /gi, "")
      //   .replace(/\-/gi, "")
      //   .replace(/\+351/gi, "")
      //   .replace(/00351/gi, "")
      //   .replace(/351/gi, "")
      //   .trim();

      // Fix phone number
      // let mbwayPhone = payload.phone;

      if (mbwayPhone.startsWith("+351")) {
        mbwayPhone = mbwayPhone.substring(4);
      }

      if (mbwayPhone.startsWith("00351")) {
        mbwayPhone = mbwayPhone.substring(5);
      }

      if (mbwayPhone.startsWith("351")) {
        mbwayPhone = mbwayPhone.substring(3);
      }

      mbwayPhone = mbwayPhone.replace(/ /gi, "").replace(/\-/gi, "").trim();

      return mbwayPhone;

      // Error handling
    } catch (error) {
      return mbwayPhone;
    }
  };

  const getMBWayReference = async () => {
    if (data?.identification?.email === undefined || data?.identification?.email === null) {
      return;
    }

    const cleanedMBWAYPhoneNumber = cleanMBWAYPhoneNumber(mbwayPhoneNumber);
    if (!cleanedMBWAYPhoneNumber) {
      formMBWay.validateFields(["phone"]);
      return;
    }
    if (cleanedMBWAYPhoneNumber.length !== 9) {
      formMBWay.validateFields(["phone"]);
      return;
    }

    setLoading(true);
    setRequestStatus(null);
    setWaitForPayment(false);
    setCheckResponse(null);
    setShowPhoneInput(false);
    setCountdownIsPlaying(true);
    setPaymentTimeout(false);

    formMBWay.setFieldsValue({ phone: cleanedMBWAYPhoneNumber });
    const payload = {
      buyer: data.identification,
      products: data.purchase_products,
      purchase_id: data.purchase_id,
      main_product: data.main_product,
      coupon: data.coupon,
      phone: cleanedMBWAYPhoneNumber,
      pathname: window.location.pathname,
      origin: window.location.origin,
      affiliate_id: data.affiliate_id,
      utm_source,
      utm_medium,
      utm_campaign,
      utm_term,
      utm_content,
      free_resolution_waiver: data.identification?.free_resolution_checkbox || false,
      is_offer: data.identification?.is_offer || false,
      offer_info: {
        gift_name: data.identification?.gift_name || "",
        gift_email: data.identification?.gift_email || "",
        gift_message: data.identification?.gift_message || "",
        gift_delivery_date: data.identification?.gift_delivery_date || "",
      },
    };

    // Disable hability to change quantity<
    actionHandler("qty_locked", true);

    const order = await createOrder({ ...payload, method: "mbway", source: "checkout" });
    if (!order.status) {
      setLoading(false);
      setErrorFetching(true);
      return;
    }

    payment_mbway_post(payload)
      .then((response) => {
        setPaymentDataResponse(response.data);
        setErrorFetching(false);
        setWaitForPayment(true);

        if (env !== "production") {
          console.log("MB WAY Provider", response.data.provider);
        }

        actionHandler("update_status", {
          action: "wait-for-payment",
          data: {
            method_id: "MBWAY",
            entity: response.data.entity,
            reference: response.data.reference,
            purchase_id: response.data.purchase_id,
            payment_unique_id: response.data.payment_unique_id,
            phone: mbwayPhoneNumber,
          },
        });
      })
      .catch((error) => {
        //  console.log("Error fetching MB WAY reference:", error?.response?.data);

        if (error?.response?.data?.statusCode === "BD-991") {
          window.location.href = "/something-went-wrong?t=BD-991";
          return;
        }

        if (error?.response?.data?.statusCode === "E0506") {
          retryOperation();

          Modal.error({
            title: t("mbway.modalTitle"),
            content: <Trans i18nKey="mbway.invalidPhoneContent" components={{ strong: <strong />, br: <br /> }} />,
            okText: t("mbway.modalOkButton"),
            onOk: () => {
              //    retryOperation();
            },
          });
          return;
        }

        setErrorFetching(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };
  const retryOperation = () => {
    setWaitForPayment(false);
    setCountdownIsPlaying(false);
    actionHandler("move", 2);
    setShowPhoneInput(true);
    setMbwayPhoneNumber("");
    formMBWay.setFieldsValue({ phone: "" });
    setCheckResponse(null);
    setErrorFetching(false);
  };
  const cancelCheckPayment = async (status) => {
    setWaitForPayment(false);
    setCountdownIsPlaying(false);
    setRequestStatus(status);
    if (stopCheckHandler) stopCheckHandler();
    actionHandler("update_status", {
      action: "checkout",
      data: {},
    });
  };

  const renderTime = useCallback(({ remainingTime }) => {
    try {
      if (remainingTime === 0) {
        return <div className="timer">{t("mbway.timerOops")}</div>;
      }

      if (remainingTime >= 60) {
        const rounded = Math.floor(remainingTime / 5) * 5;
        const minutes = Math.floor(rounded / 60);
        const seconds = rounded % 60;

        return (
          <div className="timer">
            <div className="text">{t("mbway.timerRemaining")}</div>
            <div className="value">
              {seconds > 0 ? t("mbway.timerMinutesSeconds", { minutes, seconds }) : t("mbway.timerMinutes", { minutes })}
            </div>
          </div>
        );
      }

      return (
        <div className="timer">
          <div className="text">{t("mbway.timerRemaining")}</div>
          <div className="value">{t("mbway.timerSeconds", { seconds: remainingTime })}</div>
        </div>
      );
    } catch (error) {
      return <></>;
    }
  }, [t]);

  const ShowCountdown = ({ timeout }) => {
    if (waitForPayment && !errorFetching) {
      // Calculate seconds based on the timeout (utc is string), if not provided, default to 10 seconds
      const seconds = timeout ? moment.utc(timeout).diff(moment.utc(), "seconds") : 10;

      return (
        <CountdownCircleTimer
          strokeWidth={4}
          isPlaying={countdownIsPlaying}
          size={120}
          duration={seconds} // Default to 10 seconds if not provided
          colors={["#59cf15", "#cfc615", "#cfa115", "#cf2e15"]}
          colorsTime={[300, 150, 90, 0]}
          onComplete={() => {
            setWaitForPayment(false);
            setCountdownIsPlaying(false);
            setPaymentTimeout(true);
            actionHandler("update_status", {
              action: "checkout",
              data: {},
            });
          }}
        >
          {renderTime}
        </CountdownCircleTimer>
      );
    }
    return <></>;
  };

  const ShowFaildMessage = () => {
    // console.log("Error fetching:", errorFetching, "Loading:", loading, "Payment Timeout:", paymentTimeout);
    if (loading === true) {
      return <></>;
    }
    // if (checkResponse === "Error-E0506") {
    //   return (
    //     <>
    //       <div className="error">
    //         <Alert
    //           message="Oops!"
    //           description={
    //             <>
    //               O número de telemóvel introduzido <strong>não é válido para pagamento por MB WAY.</strong>
    //               <br />
    //               Introduz um número de telemóvel configurado com o MB WAY, ou seleciona outro método de pagamento.
    //             </>
    //           }
    //           type="error"
    //           showIcon
    //         />
    //       </div>
    //       <div style={{ textAlign: "center", marginTop: "20px" }}>
    //         <CustomButton
    //           buttonStyle={customStyle}
    //           type="link"
    //           onClick={() => {
    //             retryOperation();
    //           }}
    //         >
    //           Selecionar outro método de pagamento
    //         </CustomButton>
    //       </div>
    //     </>
    //   );
    // }

    if (["Declined", "Timeout", "Error"].includes(checkResponse) === true && paymentTimeout === true) {
      return <Failed getMBWayReference={getMBWayReference} setSelectPaymentMethod={setSelectPaymentMethod} customStyle={customStyle} />;
    }

    if (["Declined", "Timeout", "Error"].includes(checkResponse) === true && paymentTimeout === false) {
      return <Declined getMBWayReference={getMBWayReference} setSelectPaymentMethod={setSelectPaymentMethod} customStyle={customStyle} />;
    }

    if (["Declined", "Timeout", "Error"].includes(requestStatus) === false && paymentTimeout === true) {
      return <Timeout getMBWayReference={getMBWayReference} setSelectPaymentMethod={setSelectPaymentMethod} customStyle={customStyle} />;
    }

    if (errorFetching && !loading) {
      return (
        <div className="error">
          <Alert
            message={t("mbway.fetchErrorTitle")}
            description={t("mbway.fetchErrorDescription")}
            type="error"
            showIcon
          />
          <div style={{ textAlign: "center" }}>
            <CustomButton buttonStyle={customStyle} type="primary" onClick={() => getMBWayReference()}>
              {t("mbway.retryButton")} <ReloadOutlined />
            </CustomButton>
          </div>
          <div style={{ textAlign: "center" }}>
            <CustomButton buttonStyle={customStyle} type="link" onClick={() => setSelectPaymentMethod({ visible: true })}>
              {t("mbway.changeMethodButton")}
            </CustomButton>
          </div>
        </div>
      );
    }
    // Default / Fallback
    return <></>;
  };

  return (
    <div className="mbway-container" style={customStyle?.primary?.backgroundColor ? { "--mbway-accent": customStyle.primary.backgroundColor } : undefined}>
      <div className="payment-data-container">
        {paid === false && (
          <>
            {loading && (
              <div style={{ marginTop: "40px", textAlign: "center", "--sp-spin-tip": customStyle?.primary?.backgroundColor || "#2b3445" }}>
                <Spin spinning={loading} tip={t("mbway.loadingTip")}>
                  <div className="loading"></div>
                </Spin>
              </div>
            )}
            {showPhoneInput && (
              <>
                <div className="title">{t("mbway.phoneInputTitle")}</div>

                <Form className="frm-mbway" layout="vertical" form={formMBWay}>
                  <Form.Item
                    name="phone"
                    validateStatus={validPhoneNumber ? "success" : "warning"}
                    rules={[
                      {
                        required: true,
                        message: t("mbway.phoneRequiredMessage"),
                      },
                      {
                        validator(rule, value) {
                          if (rule.field !== "phone") return Promise.resolve();

                          value = value.replace(/[^0-9]+/g, "").replace(/ /g, "");
                          let valid = /(9[1236]\d) ?(\d{3}) ?(\d{3})/.test(value);

                          if (value.toString().length > 9) {
                            setValidPhoneNumber(false);
                            return Promise.reject(t("mbway.phoneTooLong"));
                          }

                          if (!valid) {
                            setValidPhoneNumber(false);

                            return Promise.reject(value.toString().length === 9 ? t("mbway.phoneInvalid") : "");
                          }

                          setValidPhoneNumber(true);

                          return Promise.resolve(t("mbway.phoneValid"));
                        },
                      },
                    ]}
                    hasFeedback
                  >
                    <Input
                      className={`phoneinput ${validPhoneNumber ? "is-valid" : "not-valid"}`}
                      placeholder={t("mbway.phonePlaceholder")}
                      // onChange={(e) => setMbwayPhoneNumber(e.target.value)}
                      onChange={(e) => {
                        const cleanPhone = cleanMBWAYPhoneNumber(e.target.value);
                        setMbwayPhoneNumber(cleanPhone);
                        formMBWay.setFieldsValue({ phone: cleanPhone });
                      }}
                    />
                  </Form.Item>
                  <Form.Item>
                    <CustomButton
                      buttonStyle={customStyle}
                      //  className="submit-button"
                      disabled={!validPhoneNumber}
                      onClick={() => getMBWayReference()}
                    >
                      {t("mbway.confirmButton")} <RightOutlined />
                    </CustomButton>
                  </Form.Item>
                </Form>
              </>
            )}
            <ShowFaildMessage />

            {waitForPayment && !errorFetching && requestStatus === null && (
              <div>
                <div className="payment-loading-title">{t("mbway.waitingTitle")}</div>
                <div className="payment-loading-sub-title">{t("mbway.waitingSubtitle")}</div>
                <div style={{ display: "flex", justifyContent: "space-evenly", alignItems: "center" }}>
                  <div className="payment-loading-image">
                    <WaitingAnimation size={140} alt={t("mbway.waitingImgAlt")} />
                  </div>
                  <ShowCountdown timeout={paymentDataResponse?.timeout} />
                </div>
                <div className="payment-loading">
                  <Alert
                    className="alert-duplicates-sales"
                    message={
                      <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8 }}>
                        <LoadingOutlined style={{ color: "#f5a623" }} /> {t("mbway.awaitingConfirmation")}
                      </span>
                    }
                    type="warning"
                  />
                </div>
              </div>
            )}
          </>
        )}
      </div>

      {paid === true && <Result status="success" title={t("mbway.paidTitle")} subTitle={t("mbway.paidSubtitle")} />}
      <SelectPaymentMethodModal
        data={data}
        actionHandler={actionHandler}
        visible={selectPaymentMethod.visible}
        close={() => setSelectPaymentMethod({ visible: false })}
        customStyle={customStyle}
      />
    </div>
  );
};

export default MBWay;
